export var ResultKind;
(function (ResultKind) {
    ResultKind["Success"] = "Success";
    ResultKind["Failure"] = "Failure";
})(ResultKind || (ResultKind = {}));
